import { render, staticRenderFns } from "./ContactusPage.vue?vue&type=template&id=120917a4&scoped=true"
import script from "./ContactusPage.vue?vue&type=script&lang=js"
export * from "./ContactusPage.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/contactus.css?vue&type=style&index=0&id=120917a4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120917a4",
  null
  
)

export default component.exports